import { Component, type ErrorInfo, type ReactNode } from 'react'
import { reportError } from '../lib/errors'

/**
 * Catches render-time crashes anywhere below it: reports them to the global error popup and
 * shows a minimal recover-by-reload fallback instead of a blank screen.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false }

  static getDerivedStateFromError(): { crashed: true } {
    return { crashed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError(error.message || 'Unexpected error', info.componentStack ?? undefined)
  }

  render(): ReactNode {
    if (this.state.crashed) {
      return (
        <div className="crashscreen" role="alert">
          <div className="crashscreen-card">
            <span className="err-ic" aria-hidden="true">⚠</span>
            <h1>Something went wrong</h1>
            <p>The page hit an unexpected error.</p>
            <button className="mini ok" onClick={() => window.location.reload()}>Reload</button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
